/**
 * Página de Política de Privacidad
 *
 * Esta página muestra la información sobre el tratamiento de datos personales
 * y las políticas de privacidad de Liga ProKids.
 */

const Privacy = () => {
  // Estilos inline para asegurar que las secciones ocupen todo el ancho disponible
  const sectionStyle = {
    width: '100%',
    margin: 0,
    padding: '60px 0',
    boxSizing: 'border-box',
  };

  const containerStyle = {
    width: '100%',
    maxWidth: '1000px',
    margin: '0 auto',
    padding: '0 20px',
    boxSizing: 'border-box',
  };

  return (
    <>
      {/* Hero Section */}
      <section
        className="hero"
        style={{
          ...sectionStyle,
          backgroundColor: '#F5F5F5',
          padding: '50px 0',
          overflow: 'hidden',
        }}
      >
        <div
          className="container"
          style={{
            ...containerStyle,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            textAlign: 'center',
          }}
        >
          <h1
            style={{
              fontSize: '2.5rem',
              fontWeight: '700',
              marginBottom: '15px',
              color: '#061156',
              lineHeight: '1.2',
            }}
          >
            🔒 Política de Privacidad
          </h1>
          <p
            style={{
              fontSize: '1.2rem',
              marginBottom: '0',
              color: '#061156',
              lineHeight: '1.6',
              maxWidth: '800px',
            }}
          >
            Información sobre el tratamiento de datos personales y consentimientos.
          </p>
        </div>
      </section>

      {/* Contenido de Política de Privacidad */}
      <section
        style={{
          ...sectionStyle,
          backgroundColor: 'white',
        }}
      >
        <div className="container" style={containerStyle}>
          <div
            style={{
              maxWidth: '900px',
              margin: '0 auto',
              lineHeight: '1.7',
            }}
          >
            {/* Consentimiento explícito */}
            <div style={{ marginBottom: '50px' }}>
              <h2
                style={{
                  fontSize: '1.8rem',
                  fontWeight: '700',
                  color: '#061156',
                  marginBottom: '25px',
                  borderBottom: '3px solid #4352A9',
                  paddingBottom: '10px',
                }}
              >
                Consentimiento explícito (comercial + imágenes)
              </h2>
              <p
                style={{
                  fontSize: '1.1rem',
                  color: '#333',
                  marginBottom: '20px',
                  textAlign: 'justify',
                }}
              >
                <strong>AP8 Soccer Specialists, S.L.</strong> es el Responsable del tratamiento de los datos personales del
                Interesado y le informa de que estos datos se tratarán de conformidad con lo dispuesto en el
                Reglamento (UE) 2016/679, de 27 de abril (GDPR), la Ley Orgánica 3/2018, de 5 de diciembre
                (LOPDGDD), y la Ley (ES) 1/1982 de protección civil, derecho al honor, intimidad personal y
                familiar y a la propia imagen, por lo que se le facilita la siguiente información del tratamiento:
              </p>

              {/* Fines y legitimación */}
              <h3
                style={{
                  fontSize: '1.4rem',
                  fontWeight: '600',
                  marginBottom: '15px',
                  color: '#4352A9',
                }}
              >
                Fines y legitimación del tratamiento:
              </h3>
              <div
                style={{
                  backgroundColor: '#F8F9FF',
                  padding: '20px',
                  borderRadius: '8px',
                  marginBottom: '25px',
                  border: '1px solid #E8ECFF',
                }}
              >
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      <th style={{ textAlign: 'left', padding: '10px', borderBottom: '2px solid #4352A9', color: '#061156', fontWeight: '600' }}>Fines</th>
                      <th style={{ textAlign: 'left', padding: '10px', borderBottom: '2px solid #4352A9', color: '#061156', fontWeight: '600' }}>Legitimación</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{ padding: '10px', borderBottom: '1px solid #E0E0E0' }}>Mantener una relación comercial</td>
                      <td style={{ padding: '10px', borderBottom: '1px solid #E0E0E0' }}>Interés legítimo del responsable (art. 6.1.f GDPR)</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '10px', borderBottom: '1px solid #E0E0E0' }}>Envío de comunicaciones de productos o servicios</td>
                      <td style={{ padding: '10px', borderBottom: '1px solid #E0E0E0' }}>Consentimiento del Interesado (art. 6.1.a GDPR)</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '10px' }}>Grabación de imágenes y vídeos de las actividades llevadas a cabo por el responsable del tratamiento para dar publicidad de las mismas en los medios de comunicación</td>
                      <td style={{ padding: '10px' }}>Consentimiento del Interesado (art. 6.1.a GDPR)</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Criterios de conservación */}
              <h3
                style={{
                  fontSize: '1.4rem',
                  fontWeight: '600',
                  marginBottom: '15px',
                  color: '#4352A9',
                }}
              >
                Criterios de conservación de los datos:
              </h3>
              <p
                style={{
                  fontSize: '1.1rem',
                  color: '#333',
                  marginBottom: '25px',
                  textAlign: 'justify',
                }}
              >
                se conservarán durante no más tiempo del necesario para mantener el fin del tratamiento o mientras existan prescripciones legales que dictaminen su custodia y, cuando ya no sea necesario para ello, se suprimirán con medidas de seguridad adecuadas para garantizar la anonimización de los datos o la destrucción total de los mismos.
              </p>

              {/* Comunicación de datos */}
              <h3
                style={{
                  fontSize: '1.4rem',
                  fontWeight: '600',
                  marginBottom: '15px',
                  color: '#4352A9',
                }}
              >
                Comunicación de los datos:
              </h3>
              <p
                style={{
                  fontSize: '1.1rem',
                  color: '#333',
                  marginBottom: '25px',
                  textAlign: 'justify',
                }}
              >
                no se comunicarán los datos a terceros sin su consentimiento, salvo obligación legal.
              </p>

              {/* Consentimiento explícito */}
              <h3
                style={{
                  fontSize: '1.4rem',
                  fontWeight: '600',
                  marginBottom: '15px',
                  color: '#4352A9',
                }}
              >
                Consentimiento explícito:
              </h3>
              <p
                style={{
                  fontSize: '1.1rem',
                  color: '#333',
                  marginBottom: '25px',
                  textAlign: 'justify',
                }}
              >
                Envío de comunicaciones de productos o servicios, grabación de imágenes y vídeos para uso interno y para su publicación en medios de comunicación del responsable: blogs, webs, redes sociales, etc.
              </p>

              {/* Derechos del interesado */}
              <h3
                style={{
                  fontSize: '1.4rem',
                  fontWeight: '600',
                  marginBottom: '15px',
                  color: '#4352A9',
                }}
              >
                Derechos que asisten al Interesado:
              </h3>
              <ul
                style={{
                  fontSize: '1.1rem',
                  color: '#333',
                  marginBottom: '25px',
                  paddingLeft: '20px',
                }}
              >
                <li style={{ marginBottom: '10px' }}>Derecho a retirar el consentimiento en cualquier momento.</li>
                <li style={{ marginBottom: '10px' }}>Derecho de acceso, rectificación, portabilidad y supresión de sus datos, y de limitación u oposición a su tratamiento.</li>
                <li style={{ marginBottom: '10px' }}>Derecho a presentar una reclamación ante la Autoridad de control (www.aepd.es) si considera que el tratamiento no se ajusta a la normativa vigente.</li>
              </ul>

              {/* Datos de contacto */}
              <h3
                style={{
                  fontSize: '1.4rem',
                  fontWeight: '600',
                  marginBottom: '15px',
                  color: '#4352A9',
                }}
              >
                Datos de contacto para ejercer sus derechos:
              </h3>
              <div
                style={{
                  backgroundColor: '#F0F8FF',
                  padding: '20px',
                  borderRadius: '8px',
                  marginBottom: '25px',
                  border: '1px solid #B0D4F1',
                }}
              >
                <p style={{ fontSize: '1.1rem', color: '#333', margin: '0 0 10px 0' }}>
                  <strong>AP8 Soccer Specialists, S.L.</strong>
                </p>
                <p style={{ fontSize: '1.1rem', color: '#333', margin: '0 0 10px 0' }}>
                  Calle Madre Elísea Oliver, 1 - 03550 Sant Joan d&apos;Alacant (Alacant).
                </p>
                <p style={{ fontSize: '1.1rem', color: '#333', margin: '0' }}>
                  E-mail: contactoligaprokids@gmail.com
                </p>
              </div>

              <p
                style={{
                  fontSize: '1.1rem',
                  color: '#333',
                  marginBottom: '0',
                  textAlign: 'justify',
                  fontWeight: '600',
                }}
              >
                Aceptando la política de privacidad el Interesado o su representante legal consiente el tratamiento de sus datos en los términos expuestos.
              </p>
            </div>

            {/* Consentimiento para mensajería */}
            <div style={{ marginBottom: '50px' }}>
              <h2
                style={{
                  fontSize: '1.8rem',
                  fontWeight: '700',
                  color: '#061156',
                  marginBottom: '25px',
                  borderBottom: '3px solid #4352A9',
                  paddingBottom: '10px',
                }}
              >
                CONSENTIMIENTO PARA AÑADIR MIEMBROS A UN GRUPO DE MENSAJERÍA INSTANTÁNEA
              </h2>
              <p
                style={{
                  fontSize: '1.1rem',
                  color: '#333',
                  marginBottom: '25px',
                  textAlign: 'justify',
                }}
              >
                Conforme con lo dispuesto en el Reglamento (UE) 2016/679, de 27 de abril (GDPR), y la Ley
                Orgánica 3/2018, de 5 de diciembre (LOPDGDD), solicitamos su consentimiento para incluirle
                en el grupo responsabilidad de <strong>AP8 Soccer Specialists, S.L.</strong>, con el único fin de estar en
                continua comunicación para mejorar la experiencia en el evento, por lo que se le facilita la
                siguiente información del tratamiento:
              </p>

              {/* Miembros del grupo */}
              <h3
                style={{
                  fontSize: '1.4rem',
                  fontWeight: '600',
                  marginBottom: '15px',
                  color: '#4352A9',
                }}
              >
                MIEMBROS DEL GRUPO:
              </h3>
              <p
                style={{
                  fontSize: '1.1rem',
                  color: '#333',
                  marginBottom: '25px',
                  textAlign: 'justify',
                }}
              >
                Se considerarán miembros del grupo los que pertenezcan al mismo en el momento de enviar un mensaje; tanto los antiguos miembros como los futuros que no estén en dicho momento no se considerarán destinatarios de los datos. El administrador del grupo podrá añadir o expulsar a cualquier miembro del grupo sin previo aviso.
              </p>

              {/* Destinatarios de los datos */}
              <h3
                style={{
                  fontSize: '1.4rem',
                  fontWeight: '600',
                  marginBottom: '15px',
                  color: '#4352A9',
                }}
              >
                DESTINATARIOS DE LOS DATOS:
              </h3>
              <p
                style={{
                  fontSize: '1.1rem',
                  color: '#333',
                  marginBottom: '25px',
                  textAlign: 'justify',
                }}
              >
                Su nombre, número de teléfono y conversaciones aportadas al grupo serán visibles a los otros miembros del grupo, que, como usted, han dado su consentimiento para alcanzar dichos fines.
              </p>

              {/* Uso de los datos */}
              <h3
                style={{
                  fontSize: '1.4rem',
                  fontWeight: '600',
                  marginBottom: '15px',
                  color: '#4352A9',
                }}
              >
                USO DE LOS DATOS:
              </h3>
              <p
                style={{
                  fontSize: '1.1rem',
                  color: '#333',
                  marginBottom: '25px',
                  textAlign: 'justify',
                }}
              >
                Queda terminantemente prohibido el uso de la información contenida en el grupo para otros fines, inclusive la comunicación a terceros no pertenecientes al grupo.
              </p>

              {/* Conservación de datos */}
              <h3
                style={{
                  fontSize: '1.4rem',
                  fontWeight: '600',
                  marginBottom: '15px',
                  color: '#4352A9',
                }}
              >
                CONSERVACIÓN DE DATOS:
              </h3>
              <p
                style={{
                  fontSize: '1.1rem',
                  color: '#333',
                  marginBottom: '25px',
                  textAlign: 'justify',
                }}
              >
                Mientras se pertenezca al grupo se podrá guardar el histórico de conversaciones que sean necesarias para el fin descrito. Cuando un miembro sea expulsado del grupo deberá eliminar inmediatamente todas las conversaciones del mismo, excepto si se requiere su conservación por una obligación legal o para la legítima defensa del miembro expulsado; en ese caso se deberá bloquear toda la información y limitar su tratamiento en tanto que pudieran derivarse responsabilidades de su relación con los otros miembros del grupo. El administrador del grupo podrá conservar indefinidamente los datos y mensajes de todos los miembros que hayan permanecido en el grupo hasta la eliminación definitiva del mismo, excepto que se requiera su conservación por los mismos motivos que cualquier otro miembro del mismo.
              </p>

              {/* Derechos del usuario */}
              <h3
                style={{
                  fontSize: '1.4rem',
                  fontWeight: '600',
                  marginBottom: '15px',
                  color: '#4352A9',
                }}
              >
                DERECHOS DEL USUARIO:
              </h3>
              <p
                style={{
                  fontSize: '1.1rem',
                  color: '#333',
                  marginBottom: '25px',
                  textAlign: 'justify',
                }}
              >
                Podrá retirar este consentimiento en cualquier momento y ejercer los derechos de acceso, rectificación, portabilidad, supresión, limitación y oposición que prevé el Reglamento, comunicándolo al administrador del grupo mediante un mensaje privado. En todo caso, si considerase que el tratamiento de datos no se ajusta a la normativa vigente, siempre podrá presentar una reclamación ante la autoridad de control en www.aepd.es.
              </p>

              <p
                style={{
                  fontSize: '1.1rem',
                  color: '#333',
                  marginBottom: '0',
                  textAlign: 'justify',
                  fontWeight: '600',
                }}
              >
                Aceptando la política de privacidad consiente el tratamiento de sus datos en los términos expuestos.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Privacy;
